/**
 * Compares two semantic version strings.
 * @param a - The first version string.
 * @param b - The second version string.
 * @returns True if `a` is greater than `b`, false otherwise.
 */
export function isSemverGreater(a: string, b: string): boolean {
  const clean = (v: string) => v.split('-')[0]
  const parse = (v: string) => clean(v).split('.').map(Number)
  const [a1, a2 = 0, a3 = 0] = parse(a)
  const [b1, b2 = 0, b3 = 0] = parse(b)
  if (a1 !== b1) return a1 > b1
  if (a2 !== b2) return a2 > b2
  return a3 > b3
}

/**
 * Compares two semantic version strings.
 * @param a - The first version string.
 * @param b - The second version string.
 * @returns True if `a` is lower than `b`, false otherwise.
 */
export function isSemverLower(a: string, b: string): boolean {
  const clean = (v: string) => v.split('-')[0]
  const parse = (v: string) => clean(v).split('.').map(Number)
  const [a1, a2 = 0, a3 = 0] = parse(a)
  const [b1, b2 = 0, b3 = 0] = parse(b)
  if (a1 !== b1) return a1 < b1
  if (a2 !== b2) return a2 < b2
  return a3 < b3
}
